import React from 'react'
import styles from './styles.module.css'

// List object: { title: String, id: String, selected: Boolean }
function Input({ onChange, value, placeholder, type, dark, small, size, required, id, 'aria-label': ariaLabel }) {
  // FontSize/LineHeight precedence matches the former styled-component: `small`
  // wins over `size === 'xs'`, otherwise the default (28px/42px) from .wrapper.
  const sizeClass = small ? styles.small : (size === 'xs' ? styles.sizeXs : null)

  return (
    <input
      className={[styles.wrapper, dark && styles.dark, sizeClass].filter(Boolean).join(' ')}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      type={type}
      required={required}
      id={id}
      aria-label={ariaLabel}
    />
  )
}

export default Input
